import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from './FormStyles';
import ValidationError from './ValidationError';

const useRowStyles = makeStyles(() => ({
    // Mirrors portal/ui md-input-container's "errors spacer" row: error on the
    // left, adornment (e.g. char counter) on the right. Sharing the row keeps
    // the adornment's vertical position stable regardless of error state.
    hintRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
    },
    adornment: {
        marginLeft: 'auto',
        fontSize: '0.75rem',
        opacity: 0.7,
        pointerEvents: 'none',
    },
}));

export default function NgpField({ fieldName, children, rightAdornment }) {
    const classes = useStyles();
    const rowClasses = useRowStyles();
    const { errors } = useFormContext();
    const invalid = _.get(errors, fieldName, false);
    const message = _.get(errors, `${fieldName}.message`);

    return (
        <div className={classes.ngpFormField}>
            <div className={classes.ngpFormFieldContainer}>{children}</div>
            {rightAdornment ? (
                <div className={rowClasses.hintRow}>
                    <ValidationError invalid={invalid} message={message} />
                    <span className={rowClasses.adornment}>{rightAdornment}</span>
                </div>
            ) : (
                <ValidationError invalid={invalid} message={message} />
            )}
        </div>
    );
}
